/**
 * @description  Utils constants like time definition
 */
export default Object.freeze({
  ONE_DAY: 60 * 60 * 24 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
})
